import { render, staticRenderFns } from "./NotificationSuccess.vue?vue&type=template&id=50c96dac&scoped=true&"
import script from "./NotificationSuccess.vue?vue&type=script&lang=js&"
export * from "./NotificationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSuccess.vue?vue&type=style&index=0&id=50c96dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c96dac",
  null
  
)

export default component.exports